import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import ImageSlider from "../../../../../Artwork/pages/Wizard/components/ImageSlider";

const DetailBar = props => {
  const { instance } = props;
  const [open, setOpen] = useState(false);

  const artistDetails = [
    // { label: "Artist", value: instance?.edition.artwork.artist.name },
    { label: "Title", value: instance?.edition?.artwork?.title },
    { label: "Edition", value: instance?.edition?.number },
    { label: "Medium", value: instance?.edition?.artwork?.medium },
    { label: "Dimensions", value: instance?.edition?.artwork?.dimensions },
    { label: "Series", value: instance?.edition?.artwork?.series },
    { label: "Category", value: instance?.edition?.artwork?.categoryId },
    { label: "Weight", value: instance?.edition?.artwork?.unpackedWeight },
    { label: "Description", value: instance?.edition?.artwork?.description },
    { label: "Notes", value: instance?.notes },
  ];

  const blocksClassNames = {
    label: "w-[100px] min-w-[100px] text-xs capitalise font-bold",
    block: "flex flex-row pb-3 flex-1",
    detail: "pl-4 text-sm break-all w-full",
  };

  return (
    <>
      <div className="block w-full shrink-0 border-b border-gray-200 lg:min-h-full lg:w-auto lg:border-b-0 lg:border-r">
        {open ? (
          <div className="w-full p-4 sm:p-6 lg:min-w-[350px] lg:max-w-[400px]">
            <div className="flex w-full flex-row">
              <div className="flex-1">
                <div className="text-l font-bold">
                  Instance {instance?.name}
                </div>
              </div>
              <div>
                <ChevronLeftIcon
                  className="h-7 w-7 cursor-pointer"
                  onClick={() => setOpen(false)}
                />
              </div>
            </div>
            <div className="py-8">
              <ImageSlider
                images={instance?.edition?.artwork?.images || []}
                title=""
                previewHeight={210}
                sliderHeight={100}
                sliderWidth={110}
              />
            </div>
            {artistDetails?.map((item, index) => {
              return (
                <div className={blocksClassNames.block} key={index}>
                  <div className={blocksClassNames.label}>{item.label}</div>
                  <div className={blocksClassNames.detail}>{item.value}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex w-full items-center gap-3 px-4 py-3 lg:min-h-full lg:w-auto lg:flex-col lg:px-[14px] lg:py-[20px]">
            <ChevronRightIcon
              className="h-5 w-5 shrink-0 cursor-pointer"
              onClick={() => setOpen(true)}
            />
            <div className="text-lg font-bold lg:relative lg:flex lg:min-h-full lg:flex-1">
              <div className="whitespace-nowrap lg:absolute lg:left-2/4 lg:top-[75px] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:-rotate-90 lg:transform">
                Instance Details
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DetailBar;
